import Tab from "../model/Tab";
import {EventBus} from "../events/event.bus";
import {EVENT_APP_NAVIGATE} from "../events/app.events";
import {useResultPageStore} from "../stores/ResultPageStore";
import PreviewManager from "./PreviewManager";
import Analytics from "../util/Analytics";

class TabManager {

    listener = false;

    constructor() {
    }

    openTab(tab) {
        Analytics.send('result_tab', `open_tab_${tab.type}`);

        EventBus.$emit(EVENT_APP_NAVIGATE, tab.path, {});
    }

    createTab(tab) {
        this.store = useResultPageStore();

        let tabExists = this.store.resultPage.openTabs.filter((item) => item.path === tab.path);

        if (tabExists.length > 0) {
            return;
        }

        this.store.addTab(tab);
    }

    getTabByPath(path) {
        return  this.store.resultPage.openTabs.filter((item) => item.path === path);
    }

    removeTab(tab, currentPath) {
        this.store = useResultPageStore();

        if (tab.path === currentPath) {
            this.openTab(this.store.resultPage.openTabs[0]);
        }

        this.store.resultPage.openTabs = this.store.resultPage.openTabs.filter((item) => item.path !== tab.path);
    }

    updateTab(path, newTab ) {
        let tab = this.getTabByPath(path);
        tab[0].path = newTab.path;
        tab[0].name = newTab.name;
    }

    updateOutputTabs(job) {
        this.store = useResultPageStore();

        let tabs = this.store.resultPage.openTabs;

        tabs.forEach((tab) => {
            if (tab.path.includes('no_output_id')) {
                tab.path = tab.path.replace('no_output_id', job.apiJob.output[0].id);
                tab.name = PreviewManager.getFilenameFromOutput(job.apiJob.output[0]);
            }
        })
    }

    create() {
        return new Tab();
    }
}

export default new TabManager()